document.addEventListener("DOMContentLoaded", function() {
    var _learnq = _learnq || [];

    function addToCart(event) {
        var button = event.target.closest("form, button, .add-to-cart");
        if (!button) {
            console.log("❌ No form or button found for Add to Cart.");
            return;
        }

        // Look for the product container
        var productContainer = button.closest(".product-card, .grid__item, .product-form, .product-detail");

        // Extract product details dynamically
        var productId = button.querySelector("input[name='id']")?.value || 
                        productContainer?.querySelector("input[name='id']")?.value || 
                        "unknown";

        var productName = button.getAttribute("data-product-name") ||
                          productContainer?.querySelector(".card__title, .product-title")?.textContent?.trim() ||
                          document.querySelector("h1.product-title")?.textContent?.trim() ||
                          "Unknown Product";

        var productPrice = button.getAttribute("data-product-price") ||
                           productContainer?.querySelector(".card__price, .product-price")?.textContent?.trim() ||
                           document.querySelector("[data-product-price]")?.textContent?.trim() ||
                           "0";

        var productImage = productContainer?.querySelector(".card__image img, .product-image img")?.src ||
                           document.querySelector(".product-image img")?.src ||
                           "https://mount-it.com/default-image.jpg"; // Default fallback image

        // Ensure price is formatted correctly
        productPrice = productPrice ? parseFloat(productPrice.replace(/[^0-9.]/g, "")) : 0;

        // Create item object for Klaviyo
        var item = {
            ProductID: productId,
            Name: productName,
            Price: productPrice,
            ImageURL: productImage,
            URL: window.location.href
        };

        // Log event before sending to Klaviyo
        console.log("🛒 Klaviyo 'Added to Cart' Event Triggered:", item);

        // Push event to Klaviyo
        _learnq.push(['track', 'Added to Cart', item]);

        // Confirm that the event was sent
        console.log("✅ Event sent to Klaviyo:", item);
    }

    // Attach event listener dynamically to all Add to Cart buttons
    function trackAddToCartButtons() {
        var buttons = document.querySelectorAll(".klaviyo-track, .add-to-cart, button[type='submit'][name='add']");
        buttons.forEach(function(button) {
            button.removeEventListener('click', addToCart); // Prevent duplicate listeners
            button.addEventListener('click', addToCart);
        });

        console.log(`🔄 Tracking ${buttons.length} Add to Cart buttons.`);
    }

    // Run tracking on page load & after AJAX updates
    trackAddToCartButtons();

    // Listen for Shopify AJAX updates (important for dynamically loaded content)
    document.addEventListener('shopify:section:load', trackAddToCartButtons);
    document.addEventListener('shopify:section:unload', trackAddToCartButtons);
    document.addEventListener('shopify:section:select', trackAddToCartButtons);
    document.addEventListener('shopify:section:deselect', trackAddToCartButtons);
    document.addEventListener('shopify:section:reorder', trackAddToCartButtons);
    document.addEventListener('shopify:section:scroll', trackAddToCartButtons);
});